// Runs in the head, before the first paint: marks the page as scripted and restores the visitor's own theme choice.
// A choice exists only after a click on the theme switch; without one the system setting applies (CSS media query).
// This file has no imports or exports on purpose: it is a classic script.
(function restoreTheme(): void {
  const root = document.documentElement;
  root.classList.add("js");
  try {
    const stored = window.localStorage.getItem("theme");
    if (stored === "light" || stored === "dark") {
      root.setAttribute("data-theme", stored);
    }
  } catch {
    // Storage can be blocked (private window, site data off): the system setting applies.
  }
})();
